<template>
  <div class="ff-snackbar">
    <div class="ff-snackbar__container">
      <div v-if="!copy_triggered" class="ff-snackbar__content-container">
        <span class="ff-snackbar__info">{{text}}</span>
        <span class="ff-snackbar__action" @click="handleAction">{{cta}}</span>
      </div>
      <div v-if="copy_triggered" class="ff-snackbar__content-container">
        <span class="ff-snackbar__info">Share this link</span>
        <input class="ff-snackbar__input" v-if="copy_triggered" type="text" ref="copy" v-model="copyText">
      </div>
      <i class="ff-snackbar__dismiss" @click="dismiss"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ff-snackbar',
  props: [
    'text',
    'type',
    'cta',
    'copy'
  ],
  data () {
    return {
      copy_triggered: false,
      copy_element: null
    }
  },
  computed: {
    copyText () {
      if (!this.copy) return
      return this.copy
    }
  },
  methods: {
    handleAction () {
      if (this.copy) {
        this.copy_triggered = true
        this.$nextTick(()=> {
          this.$refs.copy.select()
        })
      }
    },
    dismiss () {
      this.$emit('dismiss')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-snackbar {
    display: block;
  }

  .ff-snackbar__container {
    font-size: $fontSize-normal;
    padding: $unit-2/1.6 $unit-2;
    border-radius: $unit-2;
    background: $color-almost-white;
    margin-bottom: $unit-1;
    flex-grow: 0;
    align-items: center;
    display: inline-flex;
  }

  .ff-snackbar__info {
    margin-right: $unit-1/2;
  }

  .ff-snackbar__action {
    color: $color-main;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .ff-snackbar__dismiss {
    display: block;
    width: 1rem;
    height: 1rem;
    background-image: url('../../assets/img/x.svg');
    background-repeat: no-repeat;
    background-size: 16px;
    background-position: 50%;
    border-radius: 2px;
    margin-left: $unit-1;

    &:hover {
      cursor: pointer;
      background-color: $color-demure;
    }
  }

  .ff-snackbar__input {
    @include input-reset;
    padding: 0;
    max-width: 5em;
    position: relative;

    &::selection {
      color: $color-white;
      background: $color-main;
    }
  }

</style>
